export default "__VITE_ASSET__bcaf217d__"